import { Col, DatePicker, DatePickerProps, Form, Input, InputRef, message, Modal, ModalProps, Row, Slider } from 'antd';
import React, { useEffect, useRef, useCallback } from 'react';
import { useForm } from 'antd/es/form/Form';
import { URGENCY_SLIDER_VALUES, SLIDER_MARKS } from 'shared/constants';
import moment from 'moment-timezone';
// import { VendorsSearch } from 'components/atoms/VendorsSearch';
import { VendorsSearch } from '../VendorsSearch';
import { InquiryForm } from 'models/Inquiry';
import { insertInquiry } from 'api/note';
import { useRecoilState } from 'recoil';
import { selectedSupplierDynamicsVendorState } from 'recoil/atoms';
import { RefSelectProps } from 'antd/lib/select';
import { ComponentLogo } from 'components/atoms/ComponentLogo';

interface Props extends ModalProps {
  onCancel: () => void;
  onSave: () => void;
}

export const InquirySubmissionModal: React.FC<Props> = ({ onCancel, onSave, ...rest }: Props) => {
  const vendorSearchRef = useRef<RefSelectProps>(null);
  const subjectRef = useRef<InputRef>(null);
  const textAreaRef = useRef<InputRef>(null);
  const [form] = useForm();

  // RECOIL STATE
  const [supplier, setSupplier] = useRecoilState(selectedSupplierDynamicsVendorState);

  useEffect(() => {
    if (rest.open) {
      if (supplier) {
        form.setFieldsValue({
          vendor: {
            value: supplier.id,
            label: supplier.name
          }
        });
      } else {
        form.resetFields();
      }
      setTimeout(() => {
        vendorSearchRef.current?.focus();
      }, 250);
    }
  }, [form, rest.open, supplier]);
  //
  // useEffect(() => {
  //   if (!rest.open) return;
  //   vendorSearchRef.current?.focus();
  // }, [rest.open]);

  const disabledDateNeededDate: DatePickerProps['disabledDate'] = (current) => {
    return current && current < moment().startOf('day');
  };

  const onOkayHandler = async () => {
    try {
      await form.validateFields();
      const data: InquiryForm = await form.getFieldsValue();
      Object.assign(data, {
        date_needed: data.date_needed ? moment(data.date_needed).format('YYYY-MM-DD') : undefined,
        vendor_id: data.vendor ? data.vendor.value : undefined,
        urgency: data.urgency ? getUrgencyValue(data.urgency) : undefined
      });
      const result = await insertInquiry(data);
      if (result) {
        message.success('Inquiry added!');
        resetForm();
        onSave();
      }
    } catch (e) {
      message.error('Please include values for required fields.');
    }
  };

  const getUrgencyValue = (urgencyValue: number) => {
    return URGENCY_SLIDER_VALUES.filter((val) => {
      return val.key === urgencyValue;
    })[0].value;
  };

  const supplierFilterChangeHandler = (item: any) => {
    setSupplier({
      supplier_category: [],
      id: item.value,
      name: item.label
    });
  };

  const resetForm = useCallback(() => {
    setSupplier(undefined);
    form.resetFields();
  }, [form, setSupplier]);

  const closeModal = () => {
    resetForm();
    onCancel();
  };

  return (
    <Modal
      {...rest}
      onCancel={closeModal}
      title={<ComponentLogo text={'Ask an NPI Analyst'} />}
      width={800}
      onOk={onOkayHandler}
      okText={'Submit'}
    >
      <Form layout={'vertical'} size={'small'} form={form} initialValues={{ urgency: 50 }}>
        <Form.Item label={'Primary Supplier'} name={'vendor'}>
          <VendorsSearch
            onChange={supplierFilterChangeHandler}
            ref={vendorSearchRef}
            labelInValue
            style={{ width: '50%' }}
            placeholder="Search for supplier"
          />
        </Form.Item>
        <Form.Item
          label={'Subject'}
          name={'subject'}
          rules={[{ required: true, message: 'Subject required' }]}
          style={{ marginBottom: 12 }}
        >
          <Input
            ref={subjectRef}
            placeholder={'Brief subject'}
            style={{ width: '100%' }}
            size={'large'}
            maxLength={100}
            showCount
            allowClear
          />
        </Form.Item>

        <Form.Item
          label={'Inquiry / Message'}
          name={'note'}
          rules={[{ required: true, message: 'Note details required' }]}
        >
          <Input.TextArea
            size="small"
            ref={textAreaRef}
            rows={4}
            placeholder="What's on your mind?"
            allowClear
            // onPressEnter={handleEnter}
          />
        </Form.Item>
        <>
          <Row justify={'space-between'} style={{ margin: '-16px 0' }}>
            <Col>
              <Form.Item label={'Urgency'} name={'urgency'}>
                <Slider
                  marks={SLIDER_MARKS}
                  defaultValue={25}
                  step={25}
                  tooltip={{ open: false }}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={
                  <div>
                    Need by <span style={{ color: '#888' }}>(Optional)</span>
                  </div>
                }
                name={'date_needed'}
              >
                <DatePicker
                  placeholder={'Select Date'}
                  disabledDate={disabledDateNeededDate}
                  size={'large'}
                  placement={'bottomRight'}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      </Form>
    </Modal>
  );
};
